import { useTranslation } from 'react-i18next';
import { AIAssistantModes, type AIAssistantMode } from 'balus-common';
import { CustomSelect, type CustomSelectOption } from './CustomSelect';

type Props = {
  value: AIAssistantMode;
  onChange: (mode: AIAssistantMode) => void;
};

/**
 * AIアシスタントのモード選択ボックス。
 * 各モードに説明文を併記したいので CustomSelect を使う。
 * チャット入力欄の下に置かれるため、ドロップダウンは上方向に開く。
 */
export function ModeSelect({ value, onChange }: Props) {
  const { t } = useTranslation();

  const label = (mode: AIAssistantMode): string =>
    mode === 'modeling' ? t('viewModel.aiChat.modeModeling') : t('viewModel.aiChat.modeChat');
  const description = (mode: AIAssistantMode): string =>
    mode === 'modeling' ? t('viewModel.aiChat.modeModelingDescription') : t('viewModel.aiChat.modeChatDescription');

  const options: CustomSelectOption<AIAssistantMode>[] = AIAssistantModes.map((mode) => ({
    value: mode,
    label: label(mode),
    description: description(mode),
  }));

  return (
    <CustomSelect
      value={value}
      options={options}
      onChange={onChange}
      openDirection="up"
      title={t('viewModel.aiChat.modeLabel')}
    />
  );
}
